// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3iXrk","title":"ClientReferral_title__2zErh","itemText":"ClientReferral_itemText__3Ha-O"};